import _ from 'lodash';
import React from 'react';

type Options = {
  label: string;
  value: string;
}[];

type SetOption = (option: string) => void;

export const dropdownKeyEventHandler =
  (options: Options, setOption: SetOption) => (e: React.KeyboardEvent) => {
    const found = options.find((option) =>
      _.startsWith(option.label.toLowerCase(), e.key.toLowerCase()),
    );
    if (found) setOption(found.value);
  };
